// The monorepo's single entry point for Zod. Import `z` from here, never from
// `zod` directly — `no-restricted-imports` enforces it in every workspace.
//
// WHY THIS MODULE EXISTS (BUG-1520): zod@4 registers its English locale — the
// source of every built-in message, e.g. "Invalid input: expected number,
// received string" — with a bare top-level `config(en())` statement inside
// `zod/v4/classic/external.js`. Its package.json nonetheless declares
// `"sideEffects": false`. Webpack believes the claim, rewires named imports
// straight to the modules that DEFINE them, never evaluates `external.js`, and
// drops `zod/v4/locales/en.js` from the bundle. Every message with no
// hand-written override then collapses to zod core's base string, the bare
// "Invalid input" — which is what admin-dev, staging and prod were serving for
// most validation failures, while local Node (no tree-shaking) looked correct.
//
// Registering the locale from OUR module fixes it for every bundler rather
// than one: this file is not marked side-effect-free, so the call below always
// survives. See `__tests__/zod-locale-bundling.test.ts`, which proves it by
// bundling with the same webpack `next build --webpack` uses.
//
// Keep this file free of TypeScript-only syntax — that test parses it as plain
// ESM with no loader in the chain.
import { z } from 'zod';

z.config(z.locales.en());

export { z };
